import { FC } from 'react';
import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { Simplify } from '../../../../../../prismicio-types';

import { IconCards } from '../assests';
import { HeroCardRange } from '../../../components';

import styles from './consolidationLoansCards.module.scss';

type Props = {
  data: Simplify<Content.HeroSliceConsolidationLoansPrimary>;
  isVisible: boolean;
};

export const ConsolidationLoansCards: FC<Props> = ({ data, isVisible }) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={`${styles.wrapper} ${isVisibleStyles}`}>
      <div className={styles.box}>
        <div className={`${styles.image} ${isVisibleStyles}`}>
          <PrismicNextImage field={data.client_photo} />
        </div>
        <div className={`${styles.amountWrapper} ${isVisibleStyles}`}>
          <div className={styles.amountTop}>
            <p className={styles.amountHeading}>{data.amount_heading}</p>
            <p className={styles.amountValue}>{data.amound_value}</p>
          </div>
          <div className={`${styles.rangeWrapper} ${isVisibleStyles}`}>
            <HeroCardRange cursor="default" value={40} />
          </div>
        </div>
      </div>
      <div className={`${styles.animatedBox} ${isVisibleStyles}`}>
        <ul className={styles.offerList}>
          {data.offer_items.map((item, index) => (
            <li key={`${item.value}-${index}`} className={styles.offerItem}>
              <p className={styles.offerDescription}>{item.description}</p>
              <p className={styles.offerValue}>{item.value}</p>
            </li>
          ))}
        </ul>
        <IconCards className={styles.cardsIcon} />
      </div>
    </article>
  );
};
